import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import * as commonDate from 'libs/commonDate';

import { IComCdItemState, IExtUserItemState, IPjt0103PState, IPjtMemberItemState, IUserItemState } from '../../models/pjt/pjt0103p_model';
  
const initialState: IPjt0103PState = {
    cmbList029  : [],   // 소속코드
    cmbList025  : [],   // 계획 등급코드
    extUserList : [],   // 외부직원목록
    userList    : [],   // 내부직원목록
    pjtMember   : {     // 프로젝트팀원
        id         : 0,
        empNo      : null,
        userNm     : '',
        pjCd       : '',                                                            // 프로젝트코드        
        pmUserId   : '',                                                            // PM사용자ID
        cusNm      : '',                                                            // 고객명
        pid        : '',                                                            // 주민번호
        memUserId  : '',                                                            // 프로젝트팀원ID
        memEmpNo   : null,                                                          // 프로젝트팀원사번
        memUserNm  : '',                                                            // 프로젝트팀원
        realInDt   : commonDate.maskDate(commonDate.getToday(), 'YYYY-MM-DD'),      // 투입일자
        realOutDt  : commonDate.maskDate(commonDate.getToday(), 'YYYY-MM-DD'),      // 철수일자
        userCtrAmt : 0,                                                             // 계약단가 
        belongDcd  : null,                                                          // 소속코드
        realManMon : 0,                                                             // 실제 총 투입 공수 계획 
        plManMon   : 0,                                                             // 계획 총 투입 공수 계획
        plInDt     : commonDate.maskDate(commonDate.getToday(), 'YYYY-MM-DD'),      // 계획 투입일자
        plOutDt    : commonDate.maskDate(commonDate.getToday(), 'YYYY-MM-DD'),      // 계획 철수일자
        actlGrdCd  : null,                                                          // 실제 프로젝트 투입 코드(특급,고급,중급,초급)
        inGrdCd    : null,                                                          // 투입 프로젝트 투입 코드(특급,고급,중급,초급)
        postCd     : '',                                                            // 직위코드
        userRole   : '',                                                            // 역활코드(PM,컨설팅,설계,분석,개발)
        extUserAmt : 0,                                                             // 외주 인건비
        roleLclf   : '',                                                            // 역할 대분류   
        roleMclf   : '',                                                            // 역할 중분류
        roleSclf   : '',                                                            // 역할 소분류
        genderDcd  : '',                                                            // 성별
        roleDtl    : ''                                                             // 역할 상세내용
    },
}

export const pjt0103p_Slice = createSlice({
    name: "pjt0103p_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState,
                                  cmbList025 : state.cmbList025,
                                  cmbList029 : state.cmbList029,
                                  userList   : state.userList});
        },
        setPjtMember: (state, action:PayloadAction<IPjtMemberItemState>) => {
            state.pjtMember = action.payload;
        },
        setCmbList029: (state, action:PayloadAction<IComCdItemState[]>) => {
            state.cmbList029 = action.payload;
        },
        setCmbList025: (state, action:PayloadAction<IComCdItemState[]>) => {
            state.cmbList025 = action.payload;
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setExtUserList: (state, action:PayloadAction<IExtUserItemState[]>) => {
            state.extUserList = action.payload;
        },
    },
});

export default pjt0103p_Slice.reducer;
export const Pjt0103pAction  = pjt0103p_Slice.actions;
export const Pjt0103pReducer = pjt0103p_Slice.reducer;